__turbopack_context__.v({
  "extraSmallContent": "EditInMapsButton-module__6vrutG__extraSmallContent",
  "smallContent": "EditInMapsButton-module__6vrutG__smallContent",
  "tooltipLabel": "EditInMapsButton-module__6vrutG__tooltipLabel",
});
